const videos = document.querySelectorAll(".adm-video-modal");
// FOR C62 COMPONENT THAT HAS ITERATED VIDEOCARDS (videoModalCardContent.cshtml)
const videoCards = document.querySelectorAll('[id^="videoCardId-"]');

let videoModalOpen;
let videoModal;
let videoModalWrapper;

for (const video of videos) {
    const parentEl = video.parentElement;
    videoModalOpen = parentEl.querySelector(".adm-video-modal-open");
    videoModalOpen.addEventListener("click", () => {
        addVideoCodeToSection(parentEl);
        openVideoModal(parentEl)
    });
}

if (videoCards) {
    for (const card of videoCards) {
        card.addEventListener("click", () => {
            const cardContent = card.parentElement.nextElementSibling;
            addVideoCodeToSection(cardContent);
            openVideoModal(cardContent)
        });
    }
}

function addVideoCodeToSection(section) {
    const textContent = section.querySelector("noscript").textContent;
    section.insertAdjacentHTML("afterbegin", textContent);
    videoModal = section.querySelector(".adm-video-modal");
}

function openVideoModal(section) {
    const videoModalClose = section.querySelector(".adm-video-modal-close");
    videoModalWrapper = section.querySelector(".adm-video-modal-wrapper");

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.querySelector(".adm-nav-sticky").style.display = "none";

    videoModalWrapper.querySelector("iframe").focus();
    videoModalWrapper.addEventListener("focusout", (event) => {
        outsideModalTab(event, videoModalClose);
    });

    window.addEventListener("click", (event) => {
        if (event.target === section.firstElementChild)
            closeVideoModal(event, section);
    });

    videoModalClose.addEventListener("click", (event) => closeVideoModal(event, section));
}

function outsideModalTab(event, videoModalClose) {
    if (!videoModalWrapper.contains(event.relatedTarget)) {
        videoModalClose.focus();
    }
}

function closeVideoModal(event, section) {
    document.body.style.overflow = "visible";
    document.documentElement.style.overflow = "visible";
    videoModalWrapper.remove();
    document.querySelector(".adm-nav-sticky").style.display = "block";
    videoModal.ariaHidden = "true";
    videoModalOpen = section.querySelector('.adm-video-modal-open');
    videoModalOpen.focus();
}